import styled from 'styled-components';

const PortalHint = styled.div`
	position: fixed;
	z-index: 9999;
	display: flex;
	align-items: center;
	gap: 5px;
	padding: 8px 12px;
	background-color: rgba(255, 255, 255, 0.95);
	border-radius: 8px;
	pointer-events: none;
	transform: translateX(-50%);

	font-family: 'GT Walsheim Pro';
	font-weight: 400;
	font-size: 13px;
	color: #000000;
	white-space: nowrap;

	&.hint-enter {
		opacity: 0;
	}

	&.hint-enter-active,
	&.hint-enter-done,
	&.hint-exit {
		opacity: 1;
	}

	&.hint-exit-active {
		opacity: 0;
	}
`;

export { PortalHint };
